
  import { Component, Vue } from 'vue-property-decorator'
  import { AppModule } from '@/store/module'

  @Component
  export default class Features extends Vue {
    features = [
      {
        img: 'https://spics.inctrip.com/956deeb2991ae6cb81c5ea9099aa565c.png',
        h5Img: 'https://spics.inctrip.com/e0240f439084f23002481f09ad5c54f1.png',
        title: '重新定義「餐廳點餐系統」: 極致個性化與交互體驗',
        width: 894,
        height: 806,
        list: [
          {
            title: '品牌自訂設計',
            desc: '根據餐飲品牌形象，自由定義頁面設計、配色及風格。'
          },
          {
            title: '多門店智能切換',
            desc: '支援餐廳品牌首頁與門店自如切換，並根據顧客位置推薦最近門店。'
          },
          {
            title: '多維度營銷廣告位',
            desc: '可設置6種廣告位，讓餐廳推廣營銷「游刃有餘」。'
          },
          {
            title: '全景交互式餐牌',
            desc: '優化UI/UX餐牌體驗，實證下單速度提升達50%。'
          },
          {
            title: '業界口碑推薦',
            desc: '餐廳老闆公認的「香港最佳手機點餐系統」。'
          }
        ]
      },
      {
        img: 'https://spics.inctrip.com/be085cee2c513638cb50d5f3ebcb5be0.png',
        h5Img: 'https://spics.inctrip.com/9a5eeaf7505da69441fbaa8cfb1cfd5a.png',
        title: '領先行業的「電子餐牌」系統：專為香港習慣優化',
        width: 1102,
        height: 704,
        list: [
          {
            title: '多元菜式模式',
            desc: '支援超過100多種菜品模式，完美支援套餐、跟餐及奉送功能，專為香港本地餐飲習慣深度優化。'
          },
          {
            title: '全業態場景適配',
            desc: '完美支援茶餐廳、茶飲店、咖啡店(Cafe)、西餐、Foodcourt及拉麵/米線店。'
          },
          {
            title: '跨平台餐牌管理',
            desc: '超級靈活的餐牌系統，提供手機及PC電腦介面進行極速編輯錄入，方便快捷。'
          }
        ]
      },
      {
        img: 'https://spics.inctrip.com/d011acd2a99d59f927247b95d70aa339.png',
        h5Img: 'https://spics.inctrip.com/5acd53d859138d245374d0f991872d33.png',
        title: '一站式「餐飲數碼解決方案」：打破營運孤島',
        width: 1034,
        height: 922,
        list: [
          {
            title: '全功能模組整合',
            desc: '由「雲端POS」、「掃碼點餐系統」到「餐飲會員」與「自動化營銷模組」等12個模組組成，一站式滿足餐廳營運要求。'
          },
          {
            title: '多元化支付對接',
            desc: '支援香港主流豐富的支付方式，結賬更流暢。'
          },
          {
            title: '硬件無縫接入',
            desc: '支援排隊系統、叫餐大屏幕及KIOSK自助點餐終端。'
          },
          {
            title: '外賣平台整合',
            desc: '支援主流外賣平台接入，提供一站式解決方案與服務。'
          }
        ]
      },
      {
        img: 'https://spics.inctrip.com/d35b4083cc377d9218f758b1597ef95e.png',
        h5Img: 'https://spics.inctrip.com/a2b6829ff70c9cafa9690f01a61153e7.png',
        title: '獨家引入Workflow概念：POS系統管理效能「提升100%」',
        width: 986,
        height: 836,
        list: [
          {
            title: '全業務模式支援',
            desc: '同時支援堂食、外賣自取、外送、外賣平台及團單等多種業務模式。'
          },
          {
            title: '標準化作業流程',
            desc: '根據業務需要設置，系統嚴格執行Workflow規範服務員操作。'
          },
          {
            title: '節省培訓成本',
            desc: '降低培訓門檻，新手服務員只需簡單培訓即可快速上崗。'
          },
          {
            title: '強化管理效率',
            desc: '減少人為差錯，降低內部管理風險，提升整體營運效率。'
          },
        ]
      },
      {
        img: 'https://spics.inctrip.com/f98699920e3e2bca2c2254d23dde48cf.png',
        h5Img: 'https://spics.inctrip.com/c942cda71e31c9b7ea14cd8648dffb72.png',
        title: '實時數據Dashboard：餐廳和數據一手掌握',
        width: 763,
        height: 878,
        list: [
          {
            title: '多維度數據展示',
            desc: '由「品牌」到「門店」，餐廳營運數據24/7實時展示。'
          },
          {
            title: '專業營運圖表',
            desc: '提供餐廳訂單、交易額及會員數據的詳細Dashboard。'
          },
          {
            title: '財務統計分析',
            desc: '自動生成餐廳財務數據統計、報表分析。'
          },
          {
            title: '智能發展建議',
            desc: '根據數據趨勢提供餐廳營運趨勢預測與建議。'
          }
        ]
      },
      {
        img: 'https://spics.inctrip.com/7b46d39a388a04af256e3df722aafb45.png',
        h5Img: 'https://spics.inctrip.com/547542f86a9d8203b463c5f2e7f374a8.png',
        title: '領先行業的「餐廳會員系統」：精準CRM營銷',
        width: 1042,
        height: 776,
        list: [
          {
            title: '靈活會員計劃',
            desc: '提供可彈性設置的會員獎賞計劃。'
          },
          {
            title: '豐富會員權益',
            desc: '支援會員價、註冊優惠券包、生日禮遇等多功能。'
          },
          {
            title: '原生錢包整合',
            desc: '支援會員卡保存至Apple Wallet或Google Pass，方便顧客隨時喚起使用。'
          },
          {
            title: '電子印花系統',
            desc: '支援電子印花累積與兌換，增加顧客回頭率。'
          },
          {
            title: '大數據精準推廣',
            desc: '強大的會員分析與篩選功能，幫助餐廳定位核心顧客，支援精選SMS推廣及優惠券發放。'
          },
          {
            title: '數據私隱安全',
            desc: '餐廳專屬會員系統，數據資產歸屬餐廳，確保會員資訊安全。'
          }
        ]
      },
      {
        img: 'https://spics.inctrip.com/6c6c10922b56733e3b9492604b0449f8.png',
        h5Img: 'https://spics.inctrip.com/e031dcc31f9d9ee1ce1465f3cbb1653d.png',
        title: '一部POS管理所有外賣平台：對接Deliveroo & Foodpanda',
        width: 908,
        height: 940,
        list: [
          {
            title: '主流平台深度對接',
            desc: 'PinMe已全面對接Foodpanda、Deliveroo等香港主流外賣平台。'
          },
          {
            title: '訂單自動同步',
            desc: '外賣訂單自動傳入PinMe POS，無需多部平板電腦，一部主機同時管理所有訂單。'
          },
          {
            title: '中央餐牌控制',
            desc: '透過PinMe後台即可統一管理各家外賣平台的餐牌、品項及設置價格。'
          },
          {
            title: '可視化對賬報表',
            desc: '提供自動化的外賣平台交易圖表及明細報表。'
          }
        ]
      },
      {
        img: 'https://spics.inctrip.com/aa1fc0c95ee06e3fcdc426870fb4fff5.png',
        h5Img: 'https://spics.inctrip.com/e9399c63a964bdba05155ed522f27ad8.png',
        title: '全自動餐廳營銷工具：24小時提升銷量',
        width: 1102,
        height: 816,
        list: [
          {
            title: '自動化規則執行',
            desc: '輕鬆設置營銷規則，系統自動執行，無需服務員額外操作。'
          },
          {
            title: '多樣化優惠券',
            desc: '支援即減券、訂單滿額券、折扣券及滿額折扣券等多種形式。'
          },
          {
            title: '菜式兌換與特價',
            desc: '支援指定菜品兌換券以及特價菜推廣活動。'
          },
          {
            title: '獨家「券包」營銷',
            desc: '獨家支援可售賣的「券包」功能，有效鎖定顧客預算。'
          }
        ]
      }
    ]

    get isH5() {
      return AppModule.isH5
    }
  }
